import React, { createContext, useCallback, useContext, useState } from "react";
import { AxiosContext } from "./AxiosContext";
import { toast } from "react-toastify";

const StationContext = createContext();

export const useStation = () => useContext(StationContext);

export const StationProvider = ({ children }) => {
  const [ipc_name, setSelectedIpcName] = useState();
  const [searchOnline, setSearchOnline] = useState();
  const [spType, setSpType] = useState();
  const [selectedUserGroupName, setSelectedUserGroupName] = useState();
  const [battery_type, setSelectedBatteryType] = useState();
  const [sp_serial_number, setSelectedStation] = useState();
  const [privacyStatus, setPrivacyStatus] = useState();
  const [location, setSelectedLocation] = useState();
  const [isLoading, setIsLoading] = useState();
  const [fetchError, setFetchError] = useState(null);
  const [state, setState] = useState({
    column: null,
    data: null,
    direction: null,
    searchResults: null,
    searchTerm: null,
    count: null,
  });

  const { axiosInstance } = useContext(AxiosContext);

  const fetchSharingpoints = useCallback(async () => {
    if (!axiosInstance) return;
    setIsLoading(true);
    setFetchError(null);
    try {
      const { data } = await axiosInstance.get("/sharingpoints", {
        params: {
          is_online: searchOnline,
          battery_type,
          user_groups: selectedUserGroupName,
          ipc_name,
          sharing_point_type: spType,
          sp_serial_number,
          is_public: privacyStatus,
          location,
        },
      });

      setState((prev) => ({ ...prev, searchResults: data.data }));
    } catch (error) {
      const message =
        error?.response?.data?.message || "Failed to fetch sharing points";
      setFetchError(message);
      toast.error(message);
    } finally {
      setIsLoading(false);
    }
  }, [
    axiosInstance,
    searchOnline,
    battery_type,
    selectedUserGroupName,
    ipc_name,
    spType,
    sp_serial_number,
    privacyStatus,
    location,
  ]);

  return (
    <StationContext.Provider
      value={{
        ipc_name,
        setSelectedIpcName,
        searchOnline,
        setSearchOnline,
        spType,
        setSpType,
        selectedUserGroupName,
        setSelectedUserGroupName,
        battery_type,
        setSelectedBatteryType,
        sp_serial_number,
        setSelectedStation,
        privacyStatus,
        setPrivacyStatus,
        location,
        setSelectedLocation,
        isLoading,
        setIsLoading,
        fetchError,
        state,
        setState,
        fetchSharingpoints,
      }}
    >
      {children}
    </StationContext.Provider>
  );
};
